
Number.prototype.formatMoney = function(c, d, t){
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "," : d,
        t = t == undefined ? "." : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
       return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

var systemCurrency = function(ISOCurrency,scheme,options){

	this.currency = ISOCurrency;
	this.currencySymbol = null;
	this.strings = {
		"millones":"{t}millones{/t}"
	}
    this.modo = 0;  //0 divisa a derecha
                    //1 divisa a izquierda
	this.scheme = scheme;
	/* this.scheme = {
		"MXN": {
			simbolo:"MXN",
			modo:0
		},
		"EUR": {
			simbolo:"€",
			modo:0
		}...
	} */

	if(typeof scheme == "undefined" || scheme == null){
		console.log("Missing object 'scheme'. Don't forget to pass the curriencies scheme.");
		return false;
	}else{
		var sc = this.getScheme(this.currency);
		if(sc){
			this.currencySymbol = sc.simbolo;
			this.modo = sc.modo;
		}
	}

	if(typeof options != "undefined"){	
		if(typeof options["strings"] != "undefined"){
			if(typeof options.strings["millones"] != "undefined"){ this.strings.millones = options.strings["millones"]}
		}
	}

}

systemCurrency.prototype.getISOCurrency = function(){
	return this.currency;
}

systemCurrency.prototype.getSymbol = function(){
	return this.currencySymbol;
}

systemCurrency.prototype.getMode = function(){
	return this.modo;
}

systemCurrency.prototype.getMoneda = function(importe,ISOCurrency,extra){
	var self = this;
	if(typeof ISOCurrency != "undefined"){
		var scheme = self.getScheme(ISOCurrency);
		return self.mostrarMoneda(importe,ISOCurrency,scheme.simbolo,scheme.modo,extra)
	}else{
		return self.mostrarMoneda(importe,null,extra);
	}
}

systemCurrency.prototype.getScheme = function(ISOCurrency){
	var self = this;
	if(typeof self.scheme[ISOCurrency] != "undefined"){
		return self.scheme[ISOCurrency];
	}
	return false;
}

systemCurrency.prototype.mostrarMoneda = function(importe,ISOCurrency,symbol,mode,extra){
	var self = this;
	if(typeof ISOCurrency == "undefined" || ISOCurrency == null){
		var divisa = self.getISOCurrency();
	}else{
		var divisa = ISOCurrency
	}

	if(typeof symbol == "undefined" || symbol == null){
		var currencySymbol = self.getSymbol();
	}else{
		var currencySymbol = symbol;
	}


	if(typeof mode == "undefined" || mode == null){
		var modo = self.getMode();
	}else{
		var modo = mode;
	}

	var currentImporte = null;
	if(isNaN(importe)){
		return null;
	}else{
		currentImporte = importe;
	}

	if(importe < 0){
		var negative = "-";
		importe = Math.abs(importe)
		currentImporte = importe;
	}else{
		var negative = "";
	}

    if(typeof extra != "undefined" && extra != null && typeof extra["shortNumber"] != "undefined" && extra["shortNumber"] && String(importe).length > 5){
        currentImporte = roundLikePHP(importe/1000000,1);
		if(String(currentImporte).length < 3 || !Number.isInteger(currentImporte)){
			currentImporte = currentImporte.formatMoney(1, ',', '.');
		}else{
			currentImporte = currentImporte.formatMoney(0, ',', '.');
		}
	
	
		currentImporte = currentImporte + self.strings.millones.substring(0,1);
	}else{
        if(String(importe).length < 3 || !Number.isInteger(importe)){
            currentImporte = parseFloat(importe).formatMoney(2, ',', '.');
        }else{
            currentImporte = parseFloat(importe).formatMoney(0, ',', '.');
        }
    }

	if(typeof extra != "undefined" && extra != null && typeof extra["wrapper"] != "undefined" && extra["wrapper"]){
		var smb = "<" + extra.wrapper + ">" + currencySymbol + "</" + extra.wrapper + ">";
	}else{
		var smb = currencySymbol;
	}

	switch(modo){
		default:
			if(modo == 1) { return negative + smb + currentImporte } else { return negative + currentImporte + smb };
	}

	function roundLikePHP(num, dec){
		var num_sign = num >= 0 ? 1 : -1;
		return parseFloat((Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec));
	}
}
